/* Header V2 - sticky (desktop) + fixed with JS offset (mobile) */
(function() {
  const header = document.querySelector('.hv2');
  if (!header) return;

  const stickyMode = header.dataset.sticky || 'on-scroll-up';
  const root = document.documentElement;

  /* Clear any leftover styles from previous display:contents approach.
     The CSS now applies position:sticky directly on the shopify-section wrapper. */
  const parent = header.closest('.shopify-section');
  if (parent) {
    parent.style.display = '';
    parent.style.position = '';
    parent.style.transform = '';
    parent.style.contain = '';
  }

  /* Measure bar heights above header (rotating bar, announcement bar) */
  let barsHeight = 0;
  let headerHeight = header.offsetHeight || 66;
  function measure() {
    barsHeight = 0;
    const sections = document.querySelectorAll('.shopify-section');
    for (const s of sections) {
      if (s.contains(header)) break;
      const visible = s.offsetHeight > 0 && getComputedStyle(s).display !== 'none';
      const isBar = s.querySelector('.rtb-section, .announcement-bar, [class*="rotating"]');
      if (visible && isBar) barsHeight += s.offsetHeight;
    }
    headerHeight = header.offsetHeight || 66;
    root.style.setProperty('--hv2-height', headerHeight + 'px');
    root.style.setProperty('--hv2-bars-height', barsHeight + 'px');
    root.style.setProperty('--hv2-stack-height', (barsHeight + headerHeight) + 'px');
  }
  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);

  /* Clear any leftover body padding from previous approaches */
  document.body.style.paddingTop = '';

  /* Scroll handler:
     • is-scrolled toggle (when past initial position)
     • Hide on scroll DOWN, reveal on swipe UP - applied on both
       desktop and mobile (mobile uses a larger threshold so finger
       jitter doesn't yo-yo the bar). */
  let ticking = false;
  let lastY = 0;
  const SCROLL_THRESHOLD_DESKTOP = 6;
  const SCROLL_THRESHOLD_MOBILE = 10;
  const HIDE_AFTER_DESKTOP = 80;
  const HIDE_AFTER_MOBILE = 140;
  function onScroll() {
    const y = Math.max(0, window.scrollY);
    header.classList.toggle('is-scrolled', y > 40);
    document.body.classList.toggle('is-scrolled-past-header', y > 20);

    const isDesktop = window.matchMedia('(min-width: 901px)').matches;
    const threshold = isDesktop ? SCROLL_THRESHOLD_DESKTOP : SCROLL_THRESHOLD_MOBILE;
    const hideAfter = isDesktop ? HIDE_AFTER_DESKTOP : HIDE_AFTER_MOBILE;
    const delta = y - lastY;
    if (Math.abs(delta) > threshold) {
      if (delta > 0 && y > hideAfter) {
        document.body.classList.add('hv2-hide-header');
      } else if (delta < 0) {
        document.body.classList.remove('hv2-hide-header');
      }
      lastY = y;
    }
    if (y < hideAfter) document.body.classList.remove('hv2-hide-header');
    ticking = false;
  }
  onScroll();
  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });

  /* Listen to cart updates to refresh the header cart count bubble */
  function refreshCartCount() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        const countEl = document.getElementById('hv2-cart-count');
        if (cart.item_count > 0) {
          if (countEl) {
            countEl.textContent = cart.item_count;
            countEl.style.display = '';
          } else {
            /* Re-create if missing */
            const cartBtn = document.querySelector('.hv2__cart-btn');
            if (cartBtn) {
              const s = document.createElement('span');
              s.className = 'hv2__cart-badge';
              s.id = 'hv2-cart-count';
              s.textContent = cart.item_count;
              cartBtn.appendChild(s);
            }
          }
        } else if (countEl) {
          countEl.style.display = 'none';
        }
      })
      .catch(() => {});
  }
  document.addEventListener('cart:refresh', refreshCartCount);
  document.documentElement.addEventListener('cart:refresh', refreshCartCount);
  document.addEventListener('cart:update', refreshCartCount);
  /* PubSub event from product-form.js */
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCartCount); } catch (e) {}
  }

  /* Search modal */
  const searchBtn = document.getElementById('hv2-search-btn');
  const searchModal = document.getElementById('hv2-search-modal');
  const searchClose = document.getElementById('hv2-search-close');
  if (searchBtn && searchModal) {
    const open = () => {
      searchModal.classList.add('open');
      document.body.classList.add('hv2-no-scroll');
      setTimeout(() => searchModal.querySelector('input[type="search"]')?.focus(), 100);
    };
    const close = () => {
      searchModal.classList.remove('open');
      document.body.classList.remove('hv2-no-scroll');
    };
    searchBtn.addEventListener('click', open);
    searchClose?.addEventListener('click', close);
    searchModal.querySelector('.hv2__search-backdrop')?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('open')) close();
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(); }
    });
  }

  /* Mobile drawer */
  const burger = document.getElementById('hv2-burger');
  const drawer = document.getElementById('hv2-drawer');
  if (burger && drawer) {
    /* Portal drawer to <body> - the section wrapper has will-change:transform
       which creates a containing block, breaking position:fixed for the drawer.
       Mounting at body level makes fixed positioning reference the viewport. */
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    const open = () => {
      drawer.classList.add('open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('hv2-no-scroll');
    };
    const close = () => {
      drawer.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hv2-no-scroll');
    };
    burger.addEventListener('click', () => {
      drawer.classList.contains('open') ? close() : open();
    });
    drawer.querySelector('.hv2__drawer-close')?.addEventListener('click', close);
    drawer.querySelector('.hv2__drawer-backdrop')?.addEventListener('click', close);
  }
})();


/* Language selector dropdown */
(function() {
  const langWrap = document.querySelector('.hv2__lang');
  if (!langWrap) return;
  const btn = langWrap.querySelector('.hv2__lang-btn');
  if (!btn) return;
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    langWrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', langWrap.classList.contains('is-open'));
  });
  document.addEventListener('click', function(e) {
    if (!langWrap.contains(e.target)) {
      langWrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
  });
})();

/* === WISHIFYY MOBILE HEADER WRAP - bulletproof fixed positioning === */
(function() {
  if (!window.matchMedia('(max-width: 989.98px)').matches) return;

  function wrapHeader() {
    if (document.getElementById('wmc-mobile-header-fixed')) return;
    var sections = document.querySelectorAll('.shopify-section-group-header-group');
    if (!sections.length) return;

    var wrapper = document.createElement('div');
    wrapper.id = 'wmc-mobile-header-fixed';

    // Insert wrapper before the first header section
    sections[0].parentNode.insertBefore(wrapper, sections[0]);

    // Move all header sections inside the wrapper
    Array.prototype.forEach.call(sections, function(s) {
      wrapper.appendChild(s);
    });

    // Measure and set body padding to match
    function setPadding() {
      var h = wrapper.offsetHeight || 0;
      document.body.style.paddingTop = h + 'px';
    }
    setPadding();
    // Re-measure after layout settles + on resize
    setTimeout(setPadding, 100);
    setTimeout(setPadding, 500);
    window.addEventListener('load', setPadding);
    window.addEventListener('resize', setPadding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapHeader);
  } else {
    wrapHeader();
  }
})();
/* === end WISHIFYY MOBILE HEADER WRAP === */


/* Nav dropdown - click to toggle (desktop); click-outside / Esc closes. */
(function() {
  var nodes = document.querySelectorAll('.hv2__nav-item');
  var ddItems = [];
  function closeAll() {
    for (var k = 0; k < ddItems.length; k++) {
      ddItems[k].classList.remove('is-open');
      var l = ddItems[k].querySelector('.hv2__nav-link');
      if (l) l.setAttribute('aria-expanded', 'false');
    }
  }
  for (var i = 0; i < nodes.length; i++) {
    (function(item) {
      if (!item.querySelector('.hv2__dd')) return;
      ddItems.push(item);
      var link = item.querySelector('.hv2__nav-link');
      if (!link) return;
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('click', function(e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        e.stopPropagation();
        var isOpen = item.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    })(nodes[i]);
  }
  if (!ddItems.length) return;
  document.addEventListener('click', function(e) {
    var inside = false;
    for (var k = 0; k < ddItems.length; k++) {
      if (ddItems[k].contains(e.target)) { inside = true; break; }
    }
    if (!inside) closeAll();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAll();
  });
})();
